"use client"
import { useState } from "react"

// Define el estado inicial
const INITIAL_STATE = {
  collapse1: true,
  collapse2: false,
  collapse3: false,
  collapse4: false,
  collapse5: false,
  collapse6: false
}

const useAccordion = () => {
  const [toggable, toggle] = useState(INITIAL_STATE)

  const handleToggle = (collapse) => {
    toggle({ ...toggable, [collapse]: !toggable[collapse] })
  }

  const handleToggleSustainabilityAccordeon = (collapse) => {
    toggle({ ...toggable, [collapse]: true })
  }

  const handleCloseAllAccordion = () => {
    toggle({
      collapse1: true,
      collapse2: true,
      collapse3: true,
      collapse4: true,
      collapse5: true,
      collapse6: true
    })
  }

  return { toggable, handleToggle, handleCloseAllAccordion, handleToggleSustainabilityAccordeon }
}

export default useAccordion
